const videoFunc = () => {
  const videoWrapper = document.querySelector('.js-video');

  videoWrapper.addEventListener('click', e => {
    e.target.muted = false;

    if (e.target.paused) {
      e.target.playVideo();
    } else {
      e.target.pauseVideo();
    }
  });
}

export default videoFunc;